import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import ReactDOM from 'react-dom'

// import styles
import './actionmenu.scss'

// Utils
import { isTouchDevice } from '../../../utils/detect'
import { translation } from '../../../utils/helpers'

class ActionMenu extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.triggerOpen = this.triggerOpen.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount () {
    this._mounted = true
    if (typeof this.props.open !== 'undefined') {
      if (this.props.open) {
        this.triggerOpen()
      }
    }
  }

  componentWillReceiveProps (nextProps) {
    if (typeof nextProps.open !== 'undefined') {
      if (this.props.open !== nextProps.open) {
        if (nextProps.open) {
          this.triggerOpen()
        }
      }
    }
  }

  componentDidUpdate () {
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClick, false)
    this._mounted = false
  }

  triggerOpen () {
    if (!this.state.isOpen) {
      document.removeEventListener('click', this.handleClick, false)
      document.addEventListener('click', this.handleClick, false)
      if (typeof this.props.onOpen === 'function') this.props.onOpen()
    } else {
      document.removeEventListener('click', this.handleClick, false)
    }
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handleClick (e) {
    let component = ReactDOM.findDOMNode(this.refs.component)
    if (e.target === component || component.contains(e.target)) {
      if (e.target.tagName.toLowerCase() === 'a') {
        this.props.handleClick(e.target)
        if (e.target.dataset.action !== 'delete') {
          if (this._mounted) {
            this.triggerOpen()
          }
        }
      }
    } else {
      if (this._mounted) {
        this.triggerOpen()
      }
    }
  }

  render () {
    let actionMenu = ''
    if (this.state.isOpen) {
      actionMenu = this.props.renderActionMenu()
    }
    let options = {}
    if (!this.props.noAriaLabel) {
      options = {
        className: 'hint--left',
        'aria-label': translation('14720')
      }
    }

    return (
      <div {...options} >
        <div className={this.props.className()} ref='component'>
          {this.props.renderActionOpener(this.triggerOpen, this.props.type, this.props.isStarted)}
          {actionMenu}
        </div>
      </div>
    )
  }
}

ActionMenu.propTypes = {
  renderActionMenu: PropTypes.func.isRequired,
  renderActionOpener: PropTypes.func.isRequired
}

ActionMenu.defaultProps = {

  className: () => {
    return 'action__menu'
  },
  renderActionOpener: (triggerOpen, type, isStarted) => {
    let imageUrl = 'icons/menu_dots16.png'
    let extraClass = ''
    if (isStarted) {
      imageUrl = 'svgs/menuicons/Menu-dots-white.svg'
    // } else {
    //   imageUrl = 'svgs/menuicons/Menu_dots-Black.svg'
    }
    if (type === 'workscreen' && isTouchDevice()) {
      imageUrl = isStarted ? 'icons/action-swipe-dots-white-22x22.png' : 'icons/action-swipe-dot-22x.png'
      extraClass = 'actionSwipe'
    }
    return (
      <span onClick={triggerOpen} className={'action_opener ' + extraClass}>
        <img src={'/images/' + imageUrl} className={'action_image ' + extraClass} />
      </span>
    )
  },
  renderActionMenu: () => {
    return (
      <div className='poppedup'>
        POPUP
      </div>
    )
  }
}

export default ActionMenu



// WEBPACK FOOTER //
// ./src/app/shared/components/ActionMenu/index.js